module.exports = __webpack_public_path__ + "static/media/UniMastery120x120.4d95fbf0.png";